var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "booking-overview"
  }, [_c('BookingSeats', {
    attrs: {
      "time-periods": _vm.timePeriods,
      "staffs": _vm.staffs,
      "services": _vm.services,
      "bookings": _vm.bookingList,
      "maximum-booking-slot-count": _vm.maximumBookingSlotCount,
      "show-mode-selection": true,
      "enable-booking-creation": true,
      "cell-min-height": 130
    },
    on: {
      "create-booking": _vm.handleCreateBooking
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }